import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from 'components/common/Link/Link'

const MenuLink = ({ contentPath, displayName = '', placeholders: { links }}) =>
  <div>
    <NavItem key={ displayName }>
      <Link to={ contentPath || '' }>{ displayName }</Link>
    </NavItem>
    { links }
  </div>

MenuLink.propTypes = {
  contentPath: PropTypes.string,
  displayName: PropTypes.string,
  placeholders: PropTypes.shape({
    links: PropTypes.array
  })
}

MenuLink.type = 'MenuLink'
MenuLink.placeholders = ['links']

export default MenuLink

const NavItem = styled.li`
  display: table-cell;
  padding: 0.5em;
`
